<script setup lang="ts">
import type { SelectRootEmits, SelectRootProps } from 'radix-vue'
import { SelectRoot, useForwardPropsEmits } from 'radix-vue'

const props = defineProps<SelectRootProps>()

type CustomEmits = SelectRootEmits & {
  'handle-change': [value: string]
}

const emits = defineEmits<CustomEmits>()

const forwarded = useForwardPropsEmits(props, emits)

const handleUpdate = (value: string) => {
  emits('update:modelValue', value)
  emits('handle-change', value)
}
</script>

<template>
  <SelectRoot v-bind="forwarded" @update:model-value="handleUpdate">
    <slot />
  </SelectRoot>
</template>
